import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  Collapse,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {

  const [openCollapseEjes, setOpenCollapseEjes] = useState(false); // Controla la expansión del menú Ejes
  const [openCollapseConocenos, setOpenCollapseConocenos] = useState(false); // Controla la expansión del menú Conócenos
  const [openDrawer, setOpenDrawer] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Efecto para cerrar los menús cuando cambie la URL
  useEffect(() => {
    setOpenCollapseEjes(false);
    setOpenCollapseConocenos(false);
    setOpenDrawer(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const getNavLinkStyles = (path) => {
    const isActive = path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

    return {
      box: {
        display: "inline-block",
        borderRadius: "0px",
        py: 0.5,
        borderBottom: "1px solid rgb(0,0,0,0)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          borderBottom: "1px solid white",
        },
      },
      button: {
        textTransform: "none",
        fontSize: "0.85rem",
        color: isActive ? "#84BFCB" : "#ffffff",
        fontWeight: isActive ? "700" : "400",
        backgroundColor: isActive ? "rgba(255, 255, 255, 0.1)" : "transparent",
        borderRadius: "20px",
        px: 1.5,
        py: 1.5,
        lineHeight: 0,
        minWidth: "auto",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: isActive ? "rgba(255, 255, 255, 0.1)" : "transparent",
        },
      },
    };
  };

  const renderDropdownMenu = (items, collapseState, setCollapseState) => (
    <Box
      sx={{
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        width: "135px",
        borderRadius: "10px",
        px: 1,
        mt: 1
      }}
    >
      {items.map((item, index, array) => (
        <Button
          key={item.label}
          color="inherit"
          onClick={() => {
            navigate(item.path);
            setCollapseState(false);
          }}
          sx={{
            textTransform: "none",
            display: "block",
            width: "100%",
            textAlign: "left",
            padding: "8px 16px",
            borderBottom: index !== array.length - 1 ? "1px solid white" : "none",
            borderRadius: 0,
            "&:hover": {
              color: '#84BFCB',
              backgroundColor: 'rgb(0,0,0,0)',
              fontWeight: '700'
            }
          }}
        >
          {item.label}
        </Button>
      ))}
    </Box>
  );

  const ejesItems = [
    { label: "Familia", path: "/ejes-de-accion/familia" },
    { label: "Empresa", path: "/ejes-de-accion/empresa" },
    { label: "Propiedad", path: "/ejes-de-accion/propiedad" }
  ];

  const conocenosItems = [
    { label: "Nosotros", path: "/nosotros" },
    { label: "Consorcio", path: "/consorcio" }
  ];

  return (
    <AppBar
      position="absolute"
      sx={{
        backgroundColor: "rgba(0,0,0,0)",
        boxShadow: "inherit",
        paddingTop: 1,
        paddingX: { xs: "1rem", sm: "2rem", md: "4rem" },
        width: "100%",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            alt="Logo"
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1739207068/ebm/EBM_logo_blanco_etu8yj.png"
            sx={{ height: "40.5px", my: 1, flexGrow: 1 }}
          />
        </Box>

        {/* Botón Hamburguesa en Móvil */}
        <IconButton
          sx={{ display: { xs: "block", md: "none" } }}
          color="inherit"
          onClick={() => setOpenDrawer(!openDrawer)}
        >
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component="img"
              alt="Menu"
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1739295431/ebm/bars-icon_ttwipo.png"
              sx={{ height: "18px", width: "auto" }}
            />
          </Box>
        </IconButton>

        {/* Drawer (Menú en móvil) */}
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          sx={{
            "& .MuiDrawer-paper": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              width: "250px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
              color: "white",
              paddingTop: "6rem",
            }}
          >
            <Box sx={getNavLinkStyles("/").box}>
              <Button color="inherit" component={Link} to="/" sx={getNavLinkStyles("/").button}>
                Inicio
              </Button>
            </Box>

            {/* Menú Conócenos en móvil */}
            <Box sx={getNavLinkStyles("/nosotros").box}>
              <Button
                sx={getNavLinkStyles("/nosotros").button}
                color="inherit"
                onClick={() => setOpenCollapseConocenos(!openCollapseConocenos)}
              >
                Conócenos
              </Button>
            </Box>
            <Collapse in={openCollapseConocenos}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {conocenosItems.map((item) => (
                  <Button
                    key={item.path}
                    color="inherit"
                    onClick={() => {
                      navigate(item.path);
                      setOpenCollapseConocenos(false);
                    }}
                    sx={{ textTransform: "none", display: "block", fontWeight: '100' }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>
            </Collapse>

            {/* Menú Ejes de acción en móvil */}
            <Box sx={getNavLinkStyles("/ejes-de-accion").box}>
              <Button
                sx={getNavLinkStyles("/ejes-de-accion").button}
                color="inherit"
                onClick={() => setOpenCollapseEjes(!openCollapseEjes)}
              >
                Ejes de acción
              </Button>
            </Box>
            <Collapse in={openCollapseEjes}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {ejesItems.map((item) => (
                  <Button
                    key={item.path}
                    color="inherit"
                    onClick={() => {
                      navigate(item.path);
                      setOpenCollapseEjes(false);
                    }}
                    sx={{ textTransform: "none", display: "block", fontWeight: '100' }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>
            </Collapse>

            <Box sx={getNavLinkStyles("/insights").box}>
              <Button sx={getNavLinkStyles("/insights").button} color="inherit" component={Link} to="/insights">
                Insights
              </Button>
            </Box>
            <Box sx={getNavLinkStyles("/hub-formativo").box}>
              <Button sx={getNavLinkStyles("/hub-formativo").button} color="inherit" component={Link} to="/hub-formativo">
                HUB Formativo
              </Button>
            </Box>
            <Box sx={{ display: "flex", border: "1px solid white", borderRadius: "20px", mt: 4 }}>
              <Button
                component={Link}
                to="/contacto"
                sx={{
                  color: isActive("/contacto") ? "rgb(0,0,0,1)" : "rgb(255,255,255,1)",
                  backgroundColor: isActive("/contacto") ? "rgb(255,255,255,0.9)" : "rgb(0,0,0,0)",
                  '&:hover': {
                    color: isActive("/contacto") ? "rgb(255,255,255,1)" : "rgb(0,0,0,1)",
                    backgroundColor: isActive("/contacto") ? "rgb(0,0,0,0)" : "rgb(255,255,255,0.9)",
                  },
                  fontSize: "0.7rem",
                  lineHeight: 1,
                  padding: "3px 15px",
                  boxShadow: "0px 2px 10px rgb(0,0,0,0.2)",
                }}
              >
                Contacto
              </Button>
            </Box>
          </Box>
        </Drawer>

        {/* Navbar en Pantallas Grandes */}
        <Box sx={{ display: { xs: "none", md: "flex" }, flexDirection: "column", alignItems: "flex-end" }}>
          <Box sx={{ display: "flex", border: "1px solid white", borderRadius: "20px" }}>
            <Button
              component={Link}
              to="/contacto"
              sx={{
                color: isActive("/contacto") ? "rgb(0,0,0,1)" : "rgb(255,255,255,1)",
                backgroundColor: isActive("/contacto") ? "rgb(255,255,255,0.9)" : "rgb(0,0,0,0)",
                '&:hover': {
                  color: isActive("/contacto") ? "rgb(255,255,255,1)" : "rgb(0,0,0,1)",
                  backgroundColor: isActive("/contacto") ? "rgb(0,0,0,0)" : "rgb(255,255,255,0.9)",
                },
                fontSize: "0.7rem",
                lineHeight: 1,
                padding: "3px 15px",
                boxShadow: "0px 2px 10px rgb(0,0,0,0.2)",
              }}
            >
              Contacto
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: { md: 'right', lg: 'space-evenly' }, width: { md: 'auto', lg: '150%' }, paddingRight: { md: 0, lg: '14%' } }}>
            <Box sx={{ ...getNavLinkStyles("/").box, borderBottom: "1px solid white" }}>
              <Button sx={getNavLinkStyles("/").button} color="inherit" component={Link} to="/">
                Inicio
              </Button>
            </Box>

            {/* Menú Conócenos en desktop */}
            <div style={{ position: "relative", display: "block" }}>
              <Box sx={getNavLinkStyles("/nosotros").box}>
                <Button
                  sx={getNavLinkStyles("/nosotros").button}
                  color="inherit"
                  onClick={() => setOpenCollapseConocenos(!openCollapseConocenos)}
                >
                  Conócenos
                </Button>
              </Box>
              {openCollapseConocenos && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    right: '110%', // Centrado horizontal respecto al botón
                    transform: "translateX(-50%)", // Corrección para centrar
                    backgroundColor: "rgba(255, 255,255, 0.25)",
                    borderRadius: "0px 0px 10px 10px",
                    borderTop: "1px solid white",
                    zIndex: 1000,
                  }}
                  onMouseLeave={() => setOpenCollapseConocenos(false)}
                >
                  {renderDropdownMenu(conocenosItems, openCollapseConocenos, setOpenCollapseConocenos)}
                </Box>
              )}
            </div>

            {/* Menú Ejes de acción en desktop */}
            <div style={{ position: "relative", display: "block" }}>
              <Box sx={getNavLinkStyles("/ejes-de-accion").box}>
                <Button
                  sx={getNavLinkStyles("/ejes-de-accion").button}
                  color="inherit"
                  onClick={() => setOpenCollapseEjes(!openCollapseEjes)}
                >
                  Ejes de acción
                </Button>
              </Box>
              {openCollapseEjes && (
                <Box
                  sx={{
                    position: "absolute",
                    backgroundColor: "rgba(255, 255,255, 0.25)",
                    borderRadius: "0px 0px 5px 5px",
                    borderTop: "1px solid white",
                  }}
                  onMouseLeave={() => setOpenCollapseEjes(false)}
                >
                  {renderDropdownMenu(ejesItems, openCollapseEjes, setOpenCollapseEjes)}
                </Box>
              )}
            </div>

            <Box sx={getNavLinkStyles("/insights").box}>
              <Button sx={getNavLinkStyles("/insights").button} color="inherit" component={Link} to="/insights">
                Insights
              </Button>
            </Box>
            <Box sx={getNavLinkStyles("/hub-formativo").box}>
              <Button sx={getNavLinkStyles("/hub-formativo").button} color="inherit" component={Link} to="/hub-formativo">
                HUB Formativo
              </Button>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}